@if (booting) {
  <div class="boot-loading">
    <img src="assets/logo/dark_logo_vertical.png" alt="Rocket Closet" />
    <div class="boot-spinner">
      <svg viewBox="0 0 64 64">
        <circle cx="32" cy="32" r="26"></circle>
      </svg>
    </div>
  </div>
}
<ion-app>
  <ion-menu contentId="main-content" type="reveal">
    <ion-header class="ion-no-border" style="padding: 20px; background-color: var(--rc-very-light-grey)">
      <ion-grid>
        <ion-grid>
          <ion-row class="no-padding">
            <ion-col>
              <h2 style="color: var(--rc-way-darker-grey)">
                <b>{{ userToString(activeUser) }}</b>
              </h2>
            </ion-col>
            <ion-col size="2">
              <ion-menu-toggle>
                <ion-button color="light">
                  <ion-icon name="close-circle-outline"></ion-icon>
                </ion-button>
              </ion-menu-toggle>
            </ion-col>
          </ion-row>
          <ion-row class="no-padding">
            @if (tryParseDate(activeUser?.createdAt); as parsedDate) {
              <p class="no-margin" style="color: var(--rc-way-darker-grey); font-size: 11px">
                Member since {{ parsedDate | date }}
              </p>
            }
          </ion-row>
          <ion-row class="no-padding">
            @if (referralPromoCode) {
              <p style="color: var(--rc-way-darker-grey)">
                Referral code
                <span class="highlight">
                  {{ referralPromoCode }}
                </span>
              </p>
            }
          </ion-row>
        </ion-grid>
      </ion-grid>
    </ion-header>
    <ion-content>
      @for (p of appPages; track p; let i = $index) {
        @if (p.children?.length > 0) {
          <ion-item (click)="selectedIndex = i" [class.selected]="selectedIndex == i" lines="none">
            <ion-text class="ion-padding" color="secondary">{{ p.title }}</ion-text>
          </ion-item>
        }
        <!-- Children List for clicked Item -->
        <ion-list class="no-padding">
          <ion-menu-toggle auto-hide="false">
            <div style="height: 100%; width: 100%; padding-left: 8px">
              @for (sub of p.children; track sub) {
                <ion-item
                  [detail]="false"
                  [routerLink]="[sub.url]"
                  class="sub-item no-padding"
                  lines="none"
                  routerDirection="root">
                  <ion-label color="primary" style="font-size: 14px">
                    {{ sub.title }}
                  </ion-label>
                </ion-item>
              }
            </div>
          </ion-menu-toggle>
        </ion-list>
      }
    </ion-content>

    <ion-footer>
      @if (showDeleteAccountRequest) {
        <ion-item
          (click)="requestDeleteAccountRequiredForAppleReviewProcess()"
          [detail]="false"
          class="clickable"
          lines="none">
          <ion-icon color="primary" ios="close-outline" md="log-out-outline" style="margin-right: 8px"></ion-icon>
          <ion-label color="primary" style="font-size: 14px">Request delete account</ion-label>
        </ion-item>
      }
      <ion-item (click)="logout()" [detail]="false" class="clickable" lines="none">
        <ion-icon color="primary" ios="log-out-outline" md="log-out-outline" style="margin-right: 8px"></ion-icon>
        <ion-label color="primary" style="font-size: 14px">Logout</ion-label>
        <ion-text>v{{ environment.appVersion }}</ion-text>
      </ion-item>
    </ion-footer>
    <ion-footer style="padding: 5px; background-color: var(--rc-very-light-grey)">
      <div class="ion-justify-content-center" style="display: flex">
        <cdn-img alt="logo" size="md" src="assets/logo/dark_logo_header.png" style="height: 60px" />
      </div>
    </ion-footer>
  </ion-menu>
  <ion-router-outlet id="main-content"></ion-router-outlet>
</ion-app>
